// @flow

import qs from 'qs';
import { pageLimit } from 'core/config';

const calculateIndex = (index: number | string) => {
  const query = window.location.search.length ? `${window.location.search}&` : '?';
  const queryObject = qs.parse(query);

  if (!!queryObject.page && +queryObject.page > 1) {
    return index + pageLimit * (+queryObject.page - 1);
  }

  // qs adds '?' to the first param
  if (!!queryObject['?page'] && +queryObject['?page'] > 1) {
    return index + pageLimit * (+queryObject['?page'] - 1);
  }

  return index;
};

export default calculateIndex;
